import {useState} from 'react';
import {MaterialTransaction} from '../../../../../envisia/material/material-management.model';
import {useMaterialTransactionHistoryMachineListQuery} from './useMaterialTransactionHistoryMachineListQuery';
import {EvButton} from '../../../../form/EvButton';
import {StringHelper} from '../../../../../common/string-helper';

interface Props {
  transaction: MaterialTransaction;
}

export function MaterialTransactionHistoryMachines(props: Props) {
  if ((props.transaction.production_machine_ids?.length ?? 0) === 0) {
    return null;
  }

  const [state, setState] = useState<{ isExpanded: boolean }>({isExpanded: false});
  const query = useMaterialTransactionHistoryMachineListQuery(props.transaction);

  const toggleExpanded: () => void = () => {
    setState({...state, isExpanded: !state.isExpanded});
  };

  switch (query.objects.length) {
    case 0:
      return <></>;

    case 1:
      return <div className="grid grid-cols-40-10-40-10">
        <div title="Es wurde eine Maschine beim Ausbuchen ausgewählt">Maschine:</div>
        <div>{query.objects[0].id}</div>
        <div>{query.objects[0].name}</div>
      </div>;

    default:
      return <div className="grid gap-1 grid-cols-40-10-40-10">
        <div className="row-span-full" title="Es wurden Maschinen beim Ausbuchen ausgewählt">Maschinen:</div>
        <div className="col-start-4">
          <EvButton variant="link" size="no-padding" onClick={toggleExpanded}>
            {state.isExpanded ?
              <i className="fa fa-minus text-storz-red"/> :
              <i className="fa fa-plus text-storz-green"/>
            }
          </EvButton>
        </div>

        {state.isExpanded ?
          <div className="grid row-span-full col-start-2 col-span-2 grid-cols-subgrid">
            {query.objects.map(m =>
              <div key={m.id} className="grid col-span-2 grid-cols-subgrid">
                <div className="col-start-1">
                  {m.id}
                </div>
                <div className="col-start-2">
                  {m.name}
                </div>
              </div>,
            )}
          </div> :
          <div className="row-span-full col-start-2 col-span-2">
            <div className="whitespace-nowrap overflow-hidden text-ellipsis">
              {StringHelper.concat(query.objects.map(m => `${m.id} ${m.name}`))}
            </div>
          </div>
        }
      </div>;
  }
}
